// Module
var code = "<svg width=\"30\" height=\"30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 7a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z\" fill=\"#fff\"/></svg>";
// Exports
module.exports = code;